<!-- Таб информации по поручению экспедитору с единым новым представлением титулов. -->
<template>
  <div class="forwarding-info__content">
    <FlowDetails
      v-if="documentFlowVisible"
      :flow="documentFlow"
      :title-details="flowTitleDetails"
      :read-only="readOnly"
      :inspectable="readOnly"
      :variant="variant"
      @title-action="handleTitleAction"
    />

  </div>
</template>

<script>
import FlowDetails from "@/components/Edo/ForwarderOrder/FlowDetails.vue";
import { forwarderOrderTitleSections } from "@/components/Edo/ForwarderOrder/infoTabSections";

export default {
  name: "EdoForwarderOrderInfoTab",

  components: {
    FlowDetails,
  },

  props: {
    document: {
      type: Object,
      required: true,
    },
    sabyUrl: {
      type: String,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "card",
      validator: (value) => ["card", "embedded", "flat"].includes(value),
    },
  },

  emits: ["edit-title1", "edit-title2", "edit-receipt"],

  computed: {
    documentFlow() {
      return this.document.document_flow || {};
    },

    documentFlowVisible() {
      return Array.isArray(this.documentFlow.steps) && this.documentFlow.steps.length > 0;
    },

    flowTitleDetails() {
      return [
        {
          key: "client",
          label: "Титул 1",
          role: "Клиент",
          title: "Поручение экспедитору",
          description: "Задание клиента экспедитору на организацию перевозки.",
          sections: this.titleSections(1),
        },
        {
          key: "expeditor",
          label: "Титул 2",
          role: "Экспедитор",
          title: "Ответ экспедитора",
          description: "Экспедитор принимает поручение и фиксирует условия выполнения.",
          sections: this.titleSections(2),
        },
      ].map((title) => ({
        ...title,
        hasData: title.sections.some((section) => section.rows?.length),
      }));
    },
  },

  methods: {
    previewRow(key, label, value) {
      if (value === null || value === undefined || value === "") return null;
      return { key, label, value };
    },

    titleSections(number) {
      return forwarderOrderTitleSections({
        document: this.document,
        number,
        row: this.previewRow,
      });
    },

    handleTitleAction({ action }) {
      if (action?.type === "saby" && this.sabyUrl) {
        window.open(this.sabyUrl, "_blank");
      } else if (action?.type === "edit-title1") {
        this.$emit("edit-title1");
      } else if (action?.type === "edit-title2") {
        this.$emit("edit-title2");
      } else if (action?.type === "edit-receipt") {
        this.$emit("edit-receipt");
      }
    },
  },
};
</script>

<style scoped>
.forwarding-info__content {
  display: grid;
  gap: 16px;
}

</style>
